<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="toc"><a class="xref" href="#/chiball0007#ch01">Chapter 1   How Can a Myth Be Modern?</a></p>
<p class="toc"><a class="xref" href="#/chiball0008#ch02">Chapter 2   John Bull on a Beach</a></p>
<p class="toc1"><i>Robinson Crusoe</i> (1719)</p>
<p class="toc"><a class="xref" href="#/chiball0009#ch03">Chapter 3   The Reanimator</a></p>
<p class="toc1"><i>Frankenstein</i> (1818)</p>
<p class="toc"><span aria-label="viii" class="page" id="pviii" role="doc-pagebreak"></span><a class="xref" href="#/chiball0010#ch04">Chapter 4   Unchaining the Beast</a></p>
<p class="toc1"><i>The Strange Case of Dr. Jekyll and Mr. Hyde</i> (1886)</p>
<p class="toc"><a class="xref" href="#/chiball0011#ch05">Chapter 5   The Body and the Blood</a></p>
<p class="toc1"><i>Dracula</i> (1897)</p>
<p class="toc"><a class="xref" href="#/chiball0012#ch06">Chapter 6   Who Shall Dwell in these Worlds</a></p>
<p class="toc1"><i>The War of the Worlds</i> (1897)</p>
<p class="toc"><a class="xref" href="#/chiball0013#ch07">Chapter 7   Reason Wears a Deerstalker</a></p>
<p class="toc1">The Sherlock Holmes stories (1887–1927)</p>
<p class="toc"><span aria-label="ix" class="page" id="pix" role="doc-pagebreak"></span><a class="xref" href="#/chiball0014#ch08">Chapter 8   I Am the Law</a></p>
<p class="toc1">Batman (1939–)</p>
<p class="toc"><a class="xref" href="#/chiball0015#ch09">Chapter 9   Myths in the Making, Myths to Come</a></p>
<p class="toc"><a class="xref" href="#/chiball0016#ch10">Chapter 10   The Mythic Mode</a></p>
<p class="tocbmf"><a class="xref" href="#/chiball0017#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chiball0018#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiball0019#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chiball0020#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/chiball0021#fn_notes">Footnotes</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-ball-0006.vue?b15e417a